export const TipoTopico = {

  VIDEO: { id: 1, nome: 'Tópico de Video', referencia: 'v', icone: 'far fa-play-circle', e3D: false },
  TEXTO: { id: 2, nome: 'Tópico de Texto', referencia: 'texto', icone: 'fas fa-align-justify', e3D: false },
  IMAGEM: { id: 3, nome: 'Tópico de Imagem', referencia: 'img', icone: 'fas fa-image', e3D: false },
  QUESTAO_OBJETIVA: { id: 4, nome: 'Tópico de Questão Objetiva', referencia: 'q/obj', icone: 'fas fa-list-ul', e3D: false },
  QUESTAO_DISCURSIVA: { id: 5, nome: 'Tópico de Questao Discursiva', referencia: 'q/dsc', icone: 'fas fa-pen-alt', e3D: false },
  PDF: { id: 6, nome: 'Tópico de PDF', referencia: 'pdf', icone: 'far fa-file-pdf', e3D: false },
  LABVIRTUAL: { id: 8, nome: 'Tópico de Laboratório Virtual', referencia: 'labVirtual', icone: 'fas fa-vial', e3D: false },
  EXPERIENCIA_IMERSIVA: { id: 9, nome: 'Tópico de Experiência Imersiva', referencia: 'experienciaImersiva', icone: 'img-fluid modelo3DIcone', e3D: true },
  QUIZ: { id: 10, nome: 'Tópico de Quiz', referencia: 'quiz', icone: 'fas fa-list-ul', e3D: false },
  FORMULARIO_AVALIATIVO: { id: 11, nome: 'Tópico de Formulário Avaliativo', referencia: 'formularioAvaliativo', icone: 'far fa-file-alt', e3D: false },
  LINK: { id: 12, nome: 'Tópico de Link', referencia: 'link', icone: 'far fa-file', e3D: false },
  LINK_EXTERNO: { id: 12, nome: 'Tópico de Link', referencia: 'link', icone: 'fas fa-external-link-alt', e3D: false },
  JALEKLINICO: { id: 13, nome: 'Tópico Jaleklínico', referencia: 'jaleklinico', icone: 'fas fa-robot', e3D: false }
}

export const TipoTopicoUtil = {

  obterTipoTopicosPorId: function (id) {
    const key = Object.keys(TipoTopico).find(item => TipoTopico[item].id === id)
    return key ? TipoTopico[key] : {}
  }

}

export default TipoTopico
